export enum CaptchaStatus {
	CREATED,
	INVALID_CREDENTIALS,
}
